import styled from "@emotion/styled";
import {PC, Mobile} from "../../../../hooks/util/useMediaquery";

import InputUserDetailPC from "./PC/InputUserDetail"
import InputUserDetailMobile from "./Mobile/InputUserDetail";

const Elem:React.FC<any> = () => {
  return (
    <>
      <PC>
        <InputUserDetailPC />
      </PC>

      <Mobile>
        <InputUserDetailMobile />
      </Mobile>
    </>
  )
};

export default Elem;